import React from 'react';
import {
  Box, Skeleton, Stack, Switch, Typography,
} from '@mui/material';


const BillableSwitch = ({
  isLoading,
  isBillable,
  setIsBillable,
}) => {
  const handleSwitchChange = (event) => {
    setIsBillable(event.target.checked);
  };

  if (isLoading) {
    return <Skeleton variant='rectangular' height={50} />;
  }

  return (
    <Stack direction='row'>
      <Box paddingRight={3} flex={1}>
        <Typography variant='subtitle1' mb={1}>
          Billable
        </Typography>
        <Typography variant='body2'>
          Override default behavior to mark this question as billable.
          This is enabled for all questions by default.
        </Typography>
      </Box>
      <Box>
        <Switch
          checked={isBillable}
          onChange={handleSwitchChange}
          inputProps={{ 'aria-label': 'Billable Switch' }}
        />
      </Box>
    </Stack>
  );
};

export default BillableSwitch;
